<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="6"
        md="5"
        lg="4"
        xl="3"
        align-self="center"
      >
        <v-card>
          <v-container>
            <v-card-text
                class="font-weight-bold title"
              >로그인</v-card-text>
              <v-divider></v-divider>

            <v-list
              flat
            >
              <v-list-item
                v-for="(item, index) in items"
                :key="item.id"
                :style="{ 'backgroundColor': item.backgroundColor }"
                class="tile"
                @click="login(item.id, index)"
              >
                <v-list-item-avatar
                  image
                  tile
                >
                  <v-img
                    contain
                    :src="item.icon"
                    :alt="item.name + ' 아이디로 로그인 버튼 이미지'"
                    width="30px"
                    height="30px"
                  />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title :class="item.fontClass">{{ item.name }} 로그인</v-list-item-title>
                </v-list-item-content>
                <div v-if="lastLoginService === item.id" class="lastLoginService">최근 로그인</div>
              </v-list-item>
            </v-list>

            <div v-if="isDev" class="dev-login mt-4">
              <v-divider></v-divider>
              <div class="dev-login-title mt-3 mb-2">🛠 개발자 로그인</div>
              <div class="dev-login-desc mb-2">
                1. 위 소셜 로그인 클릭 → production 사이트로 이동<br>
                2. 주소창의 <code>expert.richgo.ai</code>를 <code>localhost:8080</code>으로 교체<br>
                <strong>또는</strong> 아래에 refreshToken 직접 입력
              </div>
              <v-text-field
                v-model="devToken"
                label="refreshToken 붙여넣기"
                outlined
                dense
                clearable
              ></v-text-field>
              <v-btn block color="warning" @click="loginWithToken">토큰으로 로그인</v-btn>
            </div>
          </v-container>
        </v-card>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import { api } from "../mixins/api.js"
import store from "../store.js"

const LAST_LOGIN_SERVICE = "lastLoginService";

export default {
  data() {
    return {
      isDev: process.env.NODE_ENV === 'development',
      devToken: '',
      items: [
        {
          id: 'naver',
          name: '네이버',
          icon: require('../assets/naver_logo.png'),
          backgroundColor: '#1ec800',
          fontClass : 'black--text text-center'
        },
        {
          id: 'kakao',
          name: '카카오',
          icon: require('../assets/kakao_logo.png'),
          backgroundColor: '#f7e317',
          fontClass : 'black--text text-center'
        },
        {
          id: 'google',
          name: '구글',
          icon: require('../assets/google_logo.png'),
          backgroundColor: '#ffffff',
          fontClass : 'black--text text-center'
        },
        // {
        //   id: 'facebook',
        //   name: '페이스북',
        //   icon: require('../assets/facebook_logo.png'),
        //   backgroundColor: '#4267b2',
        //   fontClass : 'white--text text-center'
        // }
      ],
      lastLoginService: null
    }
  },
  created() {
    this.lastLoginService = localStorage.getItem(LAST_LOGIN_SERVICE);
  },
  methods: {
    async login(providerName, index) {
      this.$ga.event('로그인', '클릭', 'OAuth', index);

      const redirectUrl = await api.methods.loginApi(providerName);
      if (redirectUrl === null) {
          this.$router.push('/');
      } else {
          // 어떤 로그인을 시도 했는지, 저장한다.
          localStorage.setItem(LAST_LOGIN_SERVICE, providerName)
          window.location = redirectUrl;
      }
    },
    loginWithToken() {
      const token = this.devToken && this.devToken.trim();
      if (!token) {
        alert('refreshToken을 입력해주세요.');
        return;
      }
      store.commit('setRefreshToken', token);
      this.$router.push('/');
    }
  }
}
</script>

<style scoped>
.tile {
  margin: 5px;
  transition-duration: 0.5s;
  border: 0.1px solid #BDBDBD;

}
.tile:hover {
  opacity: 0.8;
}
.naver {
  background-color: #1ec800;
}
.kakao {
  background-color: #f7e317;
}
.google {
  background-color: #ffffff;
}
.facebook {
  background-color: #4267b2;
}

.lastLoginService {
  color: #F0F0F0;
  font-size: 14px;
  font-weight: 600;
  padding: 4px 6px;
  border-radius: 4px;
  background-color: #F24E1E;
  position: absolute;
  right: 12px;
}
.dev-login {
  background-color: #fff8e1;
  border-radius: 6px;
  padding: 12px;
}
.dev-login-title {
  font-weight: bold;
  font-size: 14px;
  color: #e65100;
}
.dev-login-desc {
  font-size: 12px;
  color: #555;
  line-height: 1.6;
}
.dev-login-desc code {
  background: #eee;
  padding: 1px 4px;
  border-radius: 3px;
  font-family: monospace;
}
</style>
